import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { TeachingFlow } from './TeachingFlow';
import { volumeFlow, volumes } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-185" data-mp="3yjtk0xizler">
      <div className="mx-auto max-w-6xl" data-id="element-186" data-mp="80ewtaz0o8v6">
        <SectionHeading id="volumes-heading" title={<>
              6 Professional Volumes. <Accent data-id="element-188" data-mp="10o19d8q82nu6">One Complete Teaching System.</Accent>
            </>} data-id="element-187" data-mp="81ga7m3i97g2" />

        <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-189" data-mp="mwmfg6us128c">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0_24px_50px_-36px_rgba(90,70,40,0.45)]" data-id="element-190" data-mp="qxptqox6eq7g">
              <div className="flex min-h-[170px] flex-col px-6 pb-6 pt-5" style={{
            backgroundColor: volume.accent
          }} data-id="element-191" data-mp="1jf28bwrcejdq">
                <span className="self-start rounded-full bg-white/70 px-3 py-1 font-body text-[10px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/75" data-id="element-192" data-mp="cmb1qp3knt4q">
                  Volume {volume.number}
                </span>
                <h3 className="mt-auto pt-6 font-display text-[1.55rem] font-bold leading-[1.1] text-brand-charcoal" data-id="element-193" data-mp="mcds0hjb6szd">
                  {volume.title}
                </h3>
              </div>
              <p className="flex-1 px-6 py-5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-194" data-mp="va66xkl4bym8">{volume.description}</p>
            </li>)}
        </ol>

        <TeachingFlow steps={volumeFlow} className="mt-12" data-id="element-195" data-mp="15agm3aqprg41" />
      </div>
    </section>;
}